var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWasherArmTopLowPressureCold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 159 39",
    style: {
      enableBackground: "new 0 0 159 39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00B7FF;}\r\n\t.st1{fill:#00ADEE;}\r\n\t.st2{fill:none;}\r\n\t.st3{fill:#FF001C;}\r\n\t.st4{fill:#929497;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.6,21.71c-0.7,0.15-1.15,0.84-1,1.54c0.14,0.61,0.67,1.02,1.27,1.02c0.09,0,0.18-0.01,0.28-0.03 c0.7-0.15,1.14-0.84,0.99-1.54C112.99,22,112.3,21.56,111.6,21.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.36,23.53c-0.7,0.1-1.2,0.75-1.1,1.47c0.09,0.64,0.64,1.11,1.28,1.11c0.06,0,0.12,0,0.18-0.01 c0.71-0.1,1.21-0.75,1.11-1.46C102.73,23.93,102.07,23.43,101.36,23.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.01,24.59c-0.71,0.05-1.26,0.67-1.21,1.38c0.05,0.69,0.62,1.21,1.3,1.21c0.03,0,0.06,0,0.09,0 c0.71-0.05,1.25-0.67,1.2-1.38C92.34,25.08,91.73,24.54,91.01,24.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.6,24.94c-0.71,0-1.29,0.58-1.29,1.29c0,0.72,0.58,1.3,1.29,1.3c0.72,0,1.3-0.58,1.3-1.3 C81.9,25.52,81.32,24.94,80.6,24.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.2,24.6c-0.72-0.05-1.33,0.49-1.38,1.2c-0.05,0.72,0.49,1.34,1.2,1.38c0.03,0.01,0.06,0.01,0.09,0.01 c0.68,0,1.25-0.53,1.3-1.21C71.45,25.26,70.91,24.64,70.2,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121.64,19.07c-0.69,0.21-1.07,0.94-0.86,1.62c0.18,0.56,0.69,0.91,1.24,0.91c0.13,0,0.26-0.02,0.39-0.06 c0.68-0.21,1.07-0.94,0.85-1.62C123.05,19.23,122.32,18.85,121.64,19.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.63,6.43c0.25,0.27,0.6,0.41,0.94,0.41c0.32,0,0.64-0.11,0.89-0.35c0.37-0.34,0.47-0.85,0.35-1.3h-2.47 C148.22,5.62,148.3,6.09,148.63,6.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.73,6.55c0.25,0.24,0.57,0.35,0.88,0.35c0.35,0,0.7-0.14,0.95-0.41c0.34-0.36,0.41-0.86,0.26-1.3h-2.44 C10.23,5.66,10.34,6.2,10.73,6.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.35,15.47c-0.65,0.28-0.96,1.05-0.67,1.7c0.21,0.49,0.69,0.78,1.19,0.78c0.17,0,0.35-0.03,0.52-0.1 c0.65-0.29,0.95-1.05,0.67-1.71C132.77,15.48,132.01,15.18,131.35,15.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.52,10.74c-0.61,0.38-0.8,1.18-0.43,1.79c0.25,0.39,0.67,0.61,1.11,0.61c0.23,0,0.46-0.06,0.67-0.19 c0.62-0.37,0.8-1.17,0.43-1.78C141.93,10.56,141.13,10.36,140.52,10.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.85,15.5c-0.66-0.28-1.42,0.02-1.71,0.68c-0.28,0.65,0.02,1.42,0.68,1.7c0.16,0.08,0.34,0.11,0.51,0.11 c0.5,0,0.98-0.29,1.19-0.78C30.81,16.55,30.5,15.79,29.85,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.57,19.09c-0.69-0.21-1.42,0.17-1.63,0.85c-0.21,0.69,0.17,1.42,0.86,1.63c-0.01,0-0.01,0-0.01,0 c0.13,0.04,0.26,0.06,0.39,0.06c0.55,0,1.06-0.36,1.24-0.91C40.63,20.03,40.25,19.31,39.57,19.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.68,10.79c-0.61-0.38-1.41-0.18-1.78,0.43c-0.37,0.61-0.18,1.41,0.43,1.78c0.21,0.13,0.45,0.19,0.68,0.19 c0.43,0,0.86-0.22,1.1-0.62C21.49,11.96,21.29,11.16,20.68,10.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.84,23.54c-0.71-0.09-1.36,0.4-1.46,1.11s0.4,1.37,1.11,1.46c0.06,0.01,0.12,0.02,0.18,0.02 c0.63,0,1.19-0.47,1.28-1.12C61.06,24.3,60.56,23.64,59.84,23.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.61,21.73c-0.7-0.16-1.39,0.29-1.54,0.99c-0.16,0.7,0.29,1.39,0.99,1.54c0.09,0.02,0.18,0.03,0.28,0.03 c0.59,0,1.13-0.41,1.26-1.02C50.75,22.58,50.31,21.88,49.61,21.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.24,14.88c-1.08,0.04-1.91,0.94-1.87,2.02c0.03,1.05,0.9,1.88,1.94,1.88c0.02,0,0.05,0,0.07,0 c1.07-0.04,1.91-0.95,1.87-2.03C87.21,15.68,86.31,14.84,85.24,14.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.26,5.9c-0.96,0.48-1.34,1.65-0.86,2.62c0.35,0.68,1.03,1.07,1.74,1.07c0.3,0,0.6-0.07,0.88-0.21 c0.96-0.49,1.34-1.66,0.86-2.63C126.39,5.8,125.22,5.41,124.26,5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.01,14L65.01,14c-1.07-0.14-2.05,0.62-2.18,1.69c-0.13,1.06,0.62,2.05,1.69,2.18 c0.08,0.01,0.16,0.01,0.24,0.01c0.97,0,1.81-0.72,1.93-1.7C66.83,15.12,66.07,14.13,65.01,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.01,5.88c-0.97-0.47-2.14-0.07-2.61,0.89c-0.47,0.97-0.06,2.14,0.9,2.62c0-0.01,0-0.01,0-0.01 c0.28,0.14,0.57,0.2,0.85,0.2c0.72,0,1.41-0.4,1.75-1.09C37.38,7.52,36.97,6.35,36.01,5.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.31,9.63c-1.02-0.33-2.12,0.22-2.46,1.24s0.21,2.13,1.23,2.47c0.21,0.06,0.41,0.1,0.62,0.1 c0.81,0,1.57-0.52,1.84-1.34C46.88,11.08,46.33,9.97,45.31,9.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.34,14.08c-1.07,0.12-1.83,1.09-1.7,2.17c0.12,0.99,0.96,1.71,1.93,1.71c0.08,0,0.16,0,0.23-0.01 c1.07-0.13,1.83-1.1,1.7-2.18C97.37,14.72,96.4,13.95,95.34,14.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.3,12.4c-1.05,0.23-1.72,1.27-1.49,2.33c0.2,0.91,1,1.53,1.9,1.53c0.14,0,0.27-0.02,0.41-0.05 c0.01,0,0.01,0,0.01,0c1.04-0.23,1.71-1.26,1.48-2.32C107.39,12.84,106.35,12.17,105.3,12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.02,9.73c-1.02,0.35-1.57,1.45-1.23,2.48c0.28,0.81,1.03,1.32,1.85,1.32c0.2,0,0.41-0.03,0.62-0.1 c1.02-0.34,1.56-1.45,1.22-2.47C117.14,9.94,116.03,9.39,115.02,9.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.04,12.29c-1.05-0.22-2.09,0.44-2.31,1.49c-0.24,1.05,0.43,2.09,1.48,2.33c0-0.01,0-0.01,0-0.01 c0.14,0.03,0.28,0.05,0.42,0.05c0.89,0,1.7-0.62,1.89-1.53C56.75,13.56,56.09,12.52,55.04,12.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.1,14.85c-1.07-0.04-1.98,0.79-2.03,1.86c-0.04,1.07,0.79,1.99,1.86,2.04c0.03,0,0.06,0,0.09,0 c1.04,0,1.9-0.82,1.94-1.86C77.01,15.8,76.17,14.9,75.1,14.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.54,6.95c-0.04,1.25,0.95,2.31,2.2,2.34c0.02,0,0.05,0,0.07,0c1.22,0,2.23-0.97,2.26-2.21 c0.02-0.77-0.34-1.45-0.91-1.88h-2.71C72.92,5.59,72.55,6.22,72.54,6.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.28,6.03c-0.14,1.24,0.76,2.38,2,2.52c0.09,0.01,0.18,0.01,0.26,0.01c1.14,0,2.12-0.85,2.25-2.02 c0.05-0.49-0.05-0.95-0.27-1.35h-3.98C62.41,5.45,62.31,5.73,62.28,6.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.91,6.92c0.16,0.03,0.31,0.05,0.46,0.05c1.04,0,1.97-0.72,2.21-1.77h-4.42 C52.36,6.03,53.02,6.72,53.91,6.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93.09,6.26c0.15,1.14,1.13,1.97,2.24,1.97c0.11,0,0.21,0,0.31-0.02c1.24-0.16,2.11-1.31,1.95-2.56 c-0.02-0.16-0.06-0.31-0.11-0.46h-4.27C93.09,5.53,93.04,5.89,93.09,6.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.46,6.39c0.17,0,0.34-0.02,0.52-0.06c0.66-0.15,1.18-0.59,1.48-1.14h-4 C103.86,5.93,104.63,6.39,105.46,6.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.82,7.02c0.06,1.21,1.07,2.17,2.27,2.17c0.04,0,0.07-0.01,0.11-0.01c1.25-0.06,2.22-1.13,2.15-2.39 c-0.03-0.64-0.32-1.2-0.77-1.59h-2.98C83.1,5.64,82.79,6.29,82.82,7.02z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.73,
    className: "st1",
    width: 155.55,
    height: 5.19
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    width: 159,
    height: 39
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWasherArmTopLowPressureCold);
export default __webpack_public_path__ + "static/media/washer_arm_top_low_pressure_cold.436185639c57c63ac9a911ca54883f73.svg";
export { ForwardRef as ReactComponent };